import { Action } from "@ngrx/store";
import type { MeetBackground } from "./meet-background.interface";

export const GET_MEET_BACKGROUNDS = "GET_MEET_BACKGROUNDS";
export const GET_MEET_BACKGROUNDS_SUCCESS = "GET_MEET_BACKGROUNDS_SUCCESS";
export const GET_MEET_BACKGROUNDS_FAILURE = "GET_MEET_BACKGROUNDS_FAILURE";

export const DELETE_MEET_BACKGROUND = "DELETE_MEET_BACKGROUND";
export const DELETE_MEET_BACKGROUND_SUCCESS = "DELETE_MEET_BACKGROUND_SUCCESS";
export const DELETE_MEET_BACKGROUND_FAILURE = "DELETE_MEET_BACKGROUND_FAILURE";

export class GetMeetBackgroundsAction implements Action {
  readonly type = GET_MEET_BACKGROUNDS;
}

export class GetMeetBackgroundsSuccessAction implements Action {
  readonly type = GET_MEET_BACKGROUNDS_SUCCESS;

  constructor(public payload: MeetBackground[]) {}
}

export class GetMeetBackgroundsFailureAction implements Action {
  readonly type = GET_MEET_BACKGROUNDS_FAILURE;

  constructor(public payload: unknown) {}
}

export class DeleteMeetBackgroundAction implements Action {
  readonly type = DELETE_MEET_BACKGROUND;

  constructor(public payload: string) {}
}

export class DeleteMeetBackgroundSuccessAction implements Action {
  readonly type = DELETE_MEET_BACKGROUND_SUCCESS;

  constructor(public payload: string) {}
}

export class DeleteMeetBackgroundFailureAction implements Action {
  readonly type = DELETE_MEET_BACKGROUND_FAILURE;

  constructor(public payload: unknown) {}
}

export type MeetBackgroundActions =
  | GetMeetBackgroundsAction
  | GetMeetBackgroundsSuccessAction
  | GetMeetBackgroundsFailureAction
  | DeleteMeetBackgroundAction
  | DeleteMeetBackgroundSuccessAction
  | DeleteMeetBackgroundFailureAction;
